// extracted by mini-css-extract-plugin
export default {"container":"Hq-z","brandName":"Iq-z","productName":"Jq-z","productNamePdpEnhancements":"Kq-z","breakLongProductName":"Lq-z"};